import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4657e26e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4657e26e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4657e26e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/AI合规前端-测试/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4657e26e')) {
      api.createRecord('4657e26e', component.options)
    } else {
      api.reload('4657e26e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4657e26e&scoped=true", function () {
      api.rerender('4657e26e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliance/home/recommend-law/index.vue"
export default component.exports